import React from 'react';
import Icon from 'components/AppIcon';

const EXPENSE_CATEGORIES = [
  { key: 'housing', label: 'Housing / Rent', icon: 'Home', placeholder: '1200', color: '#06B6D4' },
  { key: 'groceries', label: 'Groceries', icon: 'ShoppingCart', placeholder: '400', color: '#10B981' },
  { key: 'transportation', label: 'Transportation', icon: 'Car', placeholder: '300', color: '#F59E0B' },
  { key: 'utilities', label: 'Utilities', icon: 'Zap', placeholder: '150', color: '#8B5CF6' },
  { key: 'dining', label: 'Dining Out', icon: 'UtensilsCrossed', placeholder: '200', color: '#EF4444' },
  { key: 'entertainment', label: 'Entertainment', icon: 'Tv', placeholder: '100', color: '#EC4899' },
  { key: 'healthcare', label: 'Healthcare', icon: 'Heart', placeholder: '100', color: '#06B6D4' },
  { key: 'shopping', label: 'Shopping', icon: 'ShoppingBag', placeholder: '150', color: '#F97316' },
  { key: 'subscriptions', label: 'Subscriptions', icon: 'RefreshCw', placeholder: '50', color: '#14B8A6' },
  { key: 'savings', label: 'Savings / Investments', icon: 'PiggyBank', placeholder: '300', color: '#10B981' },
  { key: 'debt', label: 'Debt Payments', icon: 'CreditCard', placeholder: '200', color: '#EF4444' },
  { key: 'other', label: 'Other', icon: 'MoreHorizontal', placeholder: '100', color: '#94A3B8' },
];

export default function ExpensesStep({ data, onChange }) {
  const handleChange = (key, value) => {
    onChange({ ...data, [key]: value });
  };

  const total = EXPENSE_CATEGORIES?.reduce((sum, cat) => {
    return sum + (parseFloat(data?.[cat?.key]) || 0);
  }, 0);

  return (
    <div className="space-y-5">
      <div>
        <h3 className="text-base font-semibold text-[#F8FAFC] mb-1">Monthly Expenses</h3>
        <p className="text-sm text-[#94A3B8] mb-4">
          Enter your estimated monthly spending for each category. Leave blank if not applicable.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {EXPENSE_CATEGORIES?.map((cat) => (
          <div
            key={cat?.key}
            className="flex items-center gap-3 p-3 rounded-lg border border-[rgba(6,182,212,0.12)] bg-[rgba(15,23,42,0.5)]"
          >
            <div
              className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
              style={{ backgroundColor: `${cat?.color}20` }}
            >
              <Icon name={cat?.icon} size={16} color={cat?.color} strokeWidth={2} />
            </div>
            <div className="flex-1 min-w-0">
              <label className="block text-xs text-[#94A3B8] mb-1">{cat?.label}</label>
              <div className="relative">
                <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[#94A3B8] text-sm">$</span>
                <input
                  type="number"
                  min="0"
                  placeholder={cat?.placeholder}
                  value={data?.[cat?.key] || ''}
                  onChange={(e) => handleChange(cat?.key, e?.target?.value)}
                  className="w-full pl-6 pr-3 py-1.5 bg-[rgba(6,182,212,0.06)] border border-[rgba(6,182,212,0.15)] rounded text-sm text-[#F8FAFC] placeholder-[#475569] focus:outline-none focus:border-[#06B6D4] focus:ring-1 focus:ring-[rgba(6,182,212,0.3)] transition-all"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-between p-4 rounded-lg bg-[rgba(6,182,212,0.08)] border border-[rgba(6,182,212,0.2)]">
        <div className="flex items-center gap-2">
          <Icon name="Calculator" size={18} color="#06B6D4" />
          <span className="text-sm font-medium text-[#CBD5E1]">Total Monthly Expenses</span>
        </div>
        <span className="font-data text-lg font-semibold text-[#06B6D4]">
          ${total?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
        </span>
      </div>
    </div>
  );
}